import { useState } from "react";

import { PageLoader, NoDataMessage, ErrorMessage } from "components/common";
import { DEFAULT_PAGE_SIZE } from "components/constants";
import { useFetchMovies } from "hooks/reactQuery/useMoviesApi";
import useQueryUpdater from "hooks/useQueryUpdater";
import { Pagination } from "neetoui";
import { isEmpty } from "ramda";
import { useTranslation } from "react-i18next";

import Card from "./Card";
import Details from "./Modal";

const Content = ({ movieListParams, pageNumber }) => {
  const [selectedMovie, setSelectedMovie] = useState(null);
  const [shouldShowModal, setShouldShowModal] = useState(false);
  const { t } = useTranslation();
  const updateQueryParams = useQueryUpdater();

  const {
    data: { search: movieList = [], totalResults = "0" } = {},
    isError,
    isFetching,
  } = useFetchMovies(movieListParams);

  const handlePageNavigation = page => {
    updateQueryParams({ page });
  };

  const handleShowDetails = movie => {
    setSelectedMovie(movie);
    setShouldShowModal(true);
  };

  if (isFetching) return <PageLoader />;

  if (isError) return <ErrorMessage />;

  if (isEmpty(movieList)) {
    return (
      <NoDataMessage
        message={t(
          isEmpty(movieListParams.searchValue)
            ? "message.searchMovie"
            : "message.noSearchValue"
        )}
      />
    );
  }

  return (
    <>
      <div className="p-4 py-8">
        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
          {movieList.map(movieDetails => (
            <Card
              key={movieDetails.imdbId}
              {...movieDetails}
              onViewDetails={() => handleShowDetails(movieDetails)}
            />
          ))}
        </div>
        <div className="flex justify-end py-2">
          <Pagination
            count={Number(totalResults) || 0}
            navigate={handlePageNavigation}
            pageNo={pageNumber}
            pageSize={DEFAULT_PAGE_SIZE}
          />
        </div>
      </div>
      <Details
        isOpen={shouldShowModal}
        movie={selectedMovie}
        onClose={() => setShouldShowModal(false)}
      />
    </>
  );
};

export default Content;
